import React from "react";
import { Link } from "react-router-dom";
// import Select from "react-select";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import useEditCategory from "../../controllers/useEditCategory";
import InputField from "../../feature-module/components/InputField";
import ErrorMessage from "../../feature-module/components/errorMessage";

const EditSubcategories = ({ rowData, parentDetails }) => {

  const { values, functions } = useEditCategory(rowData);

  return (
    <div>
      {/* Edit Category */}
      <div className="modal fade" id="edit-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Sub Category</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">Parent Category</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={parentDetails?.name}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <Controller
                        name="name"
                        control={values.control}
                        rules={{ required: "Name is required" }}
                        render={({ field }) => (
                          <InputField
                            label="Category"
                            type="text"
                            {...field}
                          />
                        )}
                      />
                      <ErrorMessage error={values.errors.name?.message} />
                    </div>
                    {/* <div className="mb-3 input-blocks">
                      <Controller
                        name="description"
                        control={values.control}
                        rules={{ required: "Description is required" }}
                        render={({ field }) => (
                          <InputField
                            label="Description"
                            type="text"
                            value={field?.value}
                            {...field}
                          />
                        )}
                      />
                      <ErrorMessage
                        error={values.errors.description?.message}
                      />
                    </div> */}
                    <div className="mb-0">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <Controller
                          name="is_active"
                          control={values.control}
                          render={({ field }) => {
                            console.log("FIELDS", field);
                            return (
                              <>
                                <input
                                  type="checkbox"
                                  id="edit-subcategoryStatus"
                                  className="check"
                                  checked={field.value}
                                  onChange={(e) =>
                                    field.onChange(e.target.checked)
                                  }
                                />
                                <label
                                  htmlFor="edit-subcategoryStatus"
                                  className="checktoggle"
                                />
                              </>
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        onClick={functions.onCancel}
                      >
                        Cancel
                      </button>
                      <Link
                        to="#"
                        className="btn btn-submit"
                        onClick={functions.onSubmit}
                      >
                        Save Changes
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Category */}
    </div>
  );
};

EditSubcategories.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    is_active: PropTypes.bool.isRequired,
  }).isRequired,
  parentDetails: PropTypes.object.isRequired,
};

export default EditSubcategories;
